/**
 * リリースノート（DF BIRD）
 * @returns JSX.Element
 */
export const ReleaseNotesDfBird = () => {
    return (
        <div>
            {/* v1.7.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.7.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-08-05</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.7.0をリリースしました。</p>
                    <br />
                    <p>新機能</p>
                    <p>・バッチ処理機能を追加</p>
                    <br />
                    <p>機能改善</p>
                    <p>・オルソ・DSM表示の高速化</p>
                    <p>・分割処理後のデータ結合時の品質改善</p>
                    <p>・ログ出力の最適化</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・大規模データ処理時のメモリエラー発生を軽減</p>
                    <p>・その他軽微なバグ修正</p>
                    <br />
                </div>
            </div>

            {/* v1.6.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.6.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.6.2をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・Windowsセキュリティ機能への対応を改善</p>
                    <br />
                </div>
            </div>

            {/* v1.6.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.6.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-04-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.6.1をリリースしました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・電子基準点データ取得ツールで新規登録したユーザーで接続できない問題を修正</p>
                    <br />
                </div>
            </div>

            {/* v1.6.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.6.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-03-31</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.6.0をリリースしました。</p>
                    <br />
                    <p>新機能</p>
                    <p>・マルチバンドデータでの解析に対応</p>
                    <p>・電子基準点データ取得ツールを追加（PPK用）</p>
                    <br />
                    <p>機能改善</p>
                    <p>・エラー発生時に解析済みファイルを保存するように対応</p>
                    <p>・画像マッチング失敗時のエラーメッセージを追加</p>
                    <br />
                </div>
            </div>

            {/* v1.5.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.5.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.5.2をリリースしました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・Windows Updateに伴いログインに失敗する問題を修正</p>
                    <br />
                </div>
            </div>

            {/* v1.5.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.5.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.5.1をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・特徴抽出精度「ultra」の追加</p>
                    <p>・画像マッチングの一部精度向上</p>
                    <p>・詳細設定にPPK設定を追加</p>
                    <p>・作業フォルダ指定のデフォルトを「保存先フォルダ」と同じパスに変更</p>
                    <br />
                </div>
            </div>

            {/* v1.5.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.5.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-11-14</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.5.0をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・出力解像度指定の設定項目を廃止</p>
                    <p>・ジオイド補正を別メニュにツールとして追加</p>
                    <p>・エラーメッセージの詳細化対応</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・ジオイド補正に失敗した場合も処理を続行するよう修正</p>
                    <br />
                </div>
            </div>

            {/* v1.4.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.4.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-08-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.4.1をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・DSMファイルのDF Scanner における読み込みの高速化に対応</p>
                    <p>・ディスク容量不足時の警告メッセージを追加（処理前 / エラー発生時）</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・ジオイド高補正処理におけるメモリエラーの修正</p>
                    <p>・距離計算における値のずれの修正</p>
                    <p>・距離 / 面積の計算時、「戻る」または「リセット」ボタンを押しても値が更新されない不具合の修正</p>
                    <br />
                </div>
            </div>

            {/* v1.4.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.4.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-07-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.4.0をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・出力されるDSMおよび点群データにジオイド高補正を適用できる機能を追加</p>
                    <p>・点群データの出力有無を切り替えられる設定を追加</p>
                    <p>・ローリングシャッター方式のカメラに対応（対応機種の一覧はマニュアル参照）</p>
                    <p>・ライセンス機能（有効期限通知・プロキシ対応など）の改善</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・NVIDIA GeForce RTX 50シリーズへの対応</p>
                    <p>・日本語のユーザー名環境でソフトが起動しない不具合を修正</p>
                    <br />
                </div>
            </div>

            {/* v1.3.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.3.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-06-13</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.3.0をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・オルソ画像・DSMの生成精度の向上</p>
                    <p>・ソフト起動時にメニューを表示</p>
                    <p>・処理中ダイアログに最小化ボタンを追加</p>
                    <p>・各種パラメータの変更</p>
                    <br />
                </div>
            </div>

            {/* v1.2.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.2.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-04-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.2.0をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・大規模データに対して、分割処理ができるようになりました。</p>
                    <br />
                    <p>その他</p>
                    <p>・恒久版ライセンスに対応しました (DF Scanner Lite 恒久版ライセンスをご購入の場合)。</p>
                    <br />
                </div>
            </div>

            {/* v1.1.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.1.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-02-04</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.1.0をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・スピード優先モードを削除しました。</p>
                    <p>・作業フォルダを設定できるようになりました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・一部のサーバー用CPUで動作しないことがある問題を修正しました。</p>
                    <br />
                </div>
            </div>

            {/* v1.0.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.0.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-11-29</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.0.3をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・オルソ画像作成精度が向上しました。</p>
                    <p>・処理完了時の画像インポートを自動化しました。</p>
                    <br />
                </div>
            </div>

            {/* v1.0.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.0.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-11-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.0.2をリリースしました。</p>
                    <br />
                    <p>機能改善</p>
                    <p>・SfM処理を高速化しました。</p>
                    <br />
                </div>
            </div>

            {/* v1.0.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.0.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-10-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.0.1をリリースしました。</p>
                    <br />
                    <p>バグ修正</p>
                    <p>・一部のPCで起動しない問題を修正しました。</p>
                    <p>・一部のオルソ画像が適切に描画されない問題を修正しました。</p>
                    <p>・ポリゴン描画の不具合を修正しました。</p>
                    <br />
                </div>
            </div>

            {/* v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-09-18</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.0.0をリリースしました。</p>
                    <br />
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesDfBird;
